import axios from 'axios';

const apiSGV = axios.create({
  baseURL: process.env.REACT_APP_URL_API_SGV,
});

export default apiSGV;
